import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { translate } from "@td/shared_utils";

const AddParticipantButton = ({ className, ...props }) => (
  <a
    {...props}
    className={classNames("add", styles.addParticipantButton, className)}
    data-testid="add-participant-button"
  >
    {translate(null, "practice_team.participants.creation.actions", "add_participant")}
  </a>
);

AddParticipantButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

AddParticipantButton.displayName = "AddParticipantButton";

export default AddParticipantButton;
